import { render, staticRenderFns } from "./SnsPostMenu.vue?vue&type=template&id=0aa431a0&"
import script from "./SnsPostMenu.vue?vue&type=script&lang=js&"
export * from "./SnsPostMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports